// removed by extract-text-webpack-plugin
module.exports = {"container":"Layout__container___DkYLB3u","content":"Layout__content___3h-gsDI"};